'use client';

import AppLayout from '@/components/AppLayout';
import IntakeForm from './components/IntakeForm';

export default function IntakeFormPage() {
  return (
    <AppLayout>
      <IntakeForm />
    </AppLayout>
  );
}
